import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { ApiContext } from '../App';

const Dashboard = () => {
  const [files, setFiles] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { authToken } = useContext(ApiContext);
  
  // API base URL
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch user's files
        const filesResponse = await fetch(`${API_BASE_URL}/files?userId=1`, { // Would use real user ID from JWT
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (filesResponse.ok) {
          const filesData = await filesResponse.json();
          setFiles(filesData.files || []);
        }
        
        // Fetch user's jobs
        const jobsResponse = await fetch(`${API_BASE_URL}/jobs?userId=1`, { // Would use real user ID from JWT
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (jobsResponse.ok) {
          const jobsData = await jobsResponse.json();
          setJobs(jobsData.jobs || []);
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (authToken) {
      fetchData();
    }
  }, [authToken]);

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard">
      <div className="container">
        <h1>Dashboard</h1>
        
        <div className="dashboard-stats">
          <div className="stat-card">
            <h3>{files.length}</h3>
            <p>Documents</p>
          </div>
          <div className="stat-card">
            <h3>{jobs.filter(job => job.status === 'completed').length}</h3>
            <p>Translations</p>
          </div>
          <div className="stat-card">
            <h3>{jobs.filter(job => job.status === 'queued' || job.status === 'processing').length}</h3>
            <p>In Progress</p>
          </div>
        </div>

        <div className="dashboard-content">
          <div className="dashboard-section">
            <div className="section-header">
              <h2>Your Documents</h2>
              <Link to="/translate" className="btn btn-primary">Upload New</Link>
            </div>
            
            {files.length > 0 ? (
              <table className="files-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Size</th>
                    <th>Status</th>
                    <th>Uploaded</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {files.map(file => (
                    <tr key={file.id}>
                      <td>{file.original_name}</td>
                      <td>{(file.size / 1024).toFixed(2)} KB</td>
                      <td>
                        <span className={`status-badge status-${file.status}`}>
                          {file.status}
                        </span>
                      </td>
                      <td>{new Date(file.uploaded_at).toLocaleDateString()}</td>
                      <td>
                        <button className="btn btn-small">Download</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="empty-state">No documents uploaded yet.</p>
            )}
          </div>

          <div className="dashboard-section">
            <div className="section-header">
              <h2>Recent Translations</h2>
              <Link to="/translate" className="btn btn-primary">New Translation</Link>
            </div>
            
            {jobs.length > 0 ? (
              <table className="jobs-table">
                <thead>
                  <tr>
                    <th>File</th>
                    <th>Target Language</th>
                    <th>Status</th>
                    <th>Completed</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {jobs.slice(0, 5).map(job => (
                    <tr key={job.id}>
                      <td>{job.file_id.substring(0, 8)}...</td>
                      <td>{job.target_language}</td>
                      <td>
                        <span className={`status-badge status-${job.status}`}>
                          {job.status}
                        </span>
                      </td>
                      <td>{job.updated_at ? new Date(job.updated_at).toLocaleDateString() : 'N/A'}</td>
                      <td>
                        {job.status === 'completed' && (
                          <button className="btn btn-small">View</button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="empty-state">No translation jobs yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;